<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.status" @change="getTable">
          <el-radio-button :label="1">展示中</el-radio-button>
          <el-radio-button :label="2">已下架</el-radio-button>
        </el-radio-group>
      </div>
      <div style="margin-bottom: 10px">
        <el-form ref="elFormDom" inline :model="table.params" size="small">
          <el-form-item label="标题" prop="title">
            <el-input
              clearable
              v-model="table.params.title"
              placeholder="请输入"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="类别" prop="category">
            <el-select
              v-model="table.params.category"
              placeholder="请选择"
              clearable
              @change="handleSearch"
            >
              <el-option label="行业分析" :value="1"></el-option>
              <el-option label="求职技巧" :value="2"></el-option>
              <el-option label="技能培训" :value="3"></el-option>
              <el-option label="人才政策" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布类型" prop="type">
            <el-select
              v-model="table.params.type"
              placeholder="请选择"
              clearable
              @change="handleSearch"
            >
              <el-option label="视频" :value="1"></el-option>
              <el-option label="文章" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getTable"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="showEdit"
          >发布文章</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="showEdit2"
          >发布视频</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="total"
        :hasPagionation="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:cover="{ row }">
          <el-image
            style="width: 50px; height: 50px"
            :src="row.cover"
            :preview-src-list="[row.cover]"
          ></el-image>
        </template>
        <template v-slot:type="{ row }">
          <span>{{ { 1: "视频", 2: "文章" }[row.type] }}</span>
        </template>
        <template v-slot:category="{ row }">
          <span>{{
            { 1: "行业分析", 2: "求职技巧", 3: "技能培训", 4: "人才政策" }[
              row.category
            ]
          }}</span>
        </template>
        <template v-slot:action="{ row }">
          <el-button type="text" @click="handleEdit(row)">修改</el-button>
          <el-popconfirm
            style="margin-left: 10px"
            :title="`确定${row.status == 1 ? '下架' : '上架'}吗`"
            placement="top-start"
            @confirm="upRow(row)"
          >
            <el-button slot="reference" type="text">{{
              row.status == 1 ? "下架" : "上架"
            }}</el-button>
          </el-popconfirm>
          <el-popconfirm
            style="margin-left: 10px"
            title="确定删除吗"
            placement="top-start"
            @confirm="deleteRow(row)"
          >
            <el-button slot="reference" type="text" class="delBtn"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </VTable>
    </div>

    <edit ref="edit" @refresh="getTable"></edit>
    <videoEdit ref="videoEditRef" @refresh="getTable"></videoEdit>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import Edit from "./components/Edit.vue";
import videoEdit from "./components/videoEdit.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "CompanyAgentList",
  mixins: [mixinTable],
  components: {
    VTable,
    Edit,
    videoEdit,
  },
  data() {
    return {
      field: [
        { name: "cover", label: "封面", hidden: false },
        { name: "title", label: "标题", hidden: false },
        { name: "type", label: "发布类型", hidden: false },
        { name: "category", label: "类别", hidden: false },
        { name: "view_num", label: "浏览人数", hidden: false },
        { name: "create_time", label: "创建时间", hidden: false },
        { name: "action", label: "操作", width: "150", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          type: "",
          title: "",
          status: 1,
          category: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      total: 0,
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    getTable() {
      this.$http
        .get("/admin/article/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    showEdit() {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom = null;
    },
    handleEdit(row) {
      if (row.type == 1) {
        let dom = this.$refs.videoEditRef;
        dom.toggle(true);
        dom.getDetail(row);
        dom = null;
      } else {
        let dom = this.$refs.edit;
        dom.toggle(true, row);
        dom.getDetail(row);
        dom = null;
      }
    },
    showEdit2() {
      let dom = this.$refs.videoEditRef;
      dom.toggle(true);
      dom = null;
    },
    deleteRow(row) {
      this.$http.post("/admin/article/delete", { id: row.id }).then((res) => {
        if (res.code === 1) {
          this.$message.success("删除成功！");
          this.getTable();
        }
      });
    },
    upRow(row) {
      this.$http
        .post("/admin/article/updateStatus", {
          id: row.id,
          status: row.status == 1 ? 2 : 1,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功！");
            this.getTable();
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>